import get from 'lodash/get'
import * as queryString from 'query-string'
import { useNavigate } from 'features/i18n/router'

import ChatRoom from 'features/Chat/ChatRoom'
import usePageModal from 'features/Modal/hooks/usePageModal'
import { MODAL_MODE } from './config'
import { isIOS } from 'lib/device'
import { ROUTE_PATH } from 'lib/paths'

const ChatRoomModal = ({ location }) => {
  const navigate = useNavigate()
  const { open } = usePageModal()
  const { chatRoomId, reqMode } = queryString.parse(get(location, 'search'))

  return (
    <div
      className="Modal__wrapper"
      style={isIOS ? { height: window.innerHeight } : {}}
    >
      <div className="Modal__body Modal__body--ov-h">
        <ChatRoom
          id={Number(chatRoomId)}
          onClose={() => {
            reqMode == 'true'
              ? open(MODAL_MODE.REQUEST_CHAT_LIST)
              : navigate(ROUTE_PATH.CHAT)
          }}
          onMenuClicked={() => {
            open(MODAL_MODE.CHAT_ROOM_DETAIL, { chatRoomId })
          }}
          isRequestChats={reqMode == 'true'}
        />
      </div>
    </div>
  )
}

export default ChatRoomModal
